import { AttackerType } from './context/attacker-type/entity';

export const attackerTypes: AttackerType[] = [
    AttackerType.new({
        name: 'Unskilled Hacker / Script Kiddy',
        abbreviation: 'Skiddie',
        capabilities:
            'Low technical / security knowledge \r\n' +
            'Uses existing / easy-to-use hacking tools',
        motiviation:
            'Boredom \r\n' +
            'Curiosity \r\n' +
            'Rebellion \r\n' +
            'Opportunity',
        typeOfAccess: 'Internet \r\n' + 'Unprotected physical interfaces',
    }),
    AttackerType.new({
        name: 'Skilled Hacker',
        abbreviation: 'Hacker',
        capabilities:
            'High technical / security knowledge \r\n' +
            'Uses, adapts, and creates hacking tools \r\n' +
            'Engages in social engineering',
        motiviation:
            'Challenge, ego, status, reputation \r\n' +
            'Political aims, activism \r\n' +
            'Financial interest (e.g., blackmail, theft) \r\n' +
            'Industrial espionage by third parties (intelligence agencies, companies, foreign governments, or other governmental interests) \r\n' +
            'Theft of intellectual property by third parties \r\n' +
            'Reputation damage to target organizations by third parties \r\n' +
            'Enhances or unlocks functionality for free',
        typeOfAccess:
            'Internet \r\n' +
            'Unprotected or poorly protected physical interfaces \r\n' +
            'Test environments \r\n' +
            'Purchasable devices/equipment',
    }),
    AttackerType.new({
        name: 'Security Researcher',
        abbreviation: 'Researcher',
        capabilities:
            'High technical / security knowledge \r\n' +
            'Uses, adapts, and creates hacking tools \r\n' +
            'Engages in social engineering',
        motiviation:
            'Ego, status, academic reputation \r\n' +
            'Research funding or sponsorship \r\n' +
            'Business development for own security company',
        typeOfAccess:
            'Acquired (purchased or stolen) test environment with full logical and physical level of access',
    }),
    AttackerType.new({
        name: 'Penetration Tester',
        abbreviation: 'Pen-tester',
        capabilities:
            'High technical / security knowledge \r\n' +
            'Uses, adapts, and creates hacking tools',
        motiviation: 'Performs penetration tests on behalf of customers',
        typeOfAccess:
            'Test environment with varying levels of logical and physical access, usually comparable to that of a regular user or skilled hacker',
    }),
    AttackerType.new({
        name: 'Malicious User',
        abbreviation: 'Mal. User',
        capabilities:
            'Low technical knowledge \r\n Limited internal / insider knowledge',
        motiviation:
            'Ego, curiosity, rebellion, revenge \r\n' +
            'Enhances or unlocks functionality for free',
        typeOfAccess:
            'Intranet \r\n' +
            'Physical and logical access as a part of standard user activities',
    }),
    AttackerType.new({
        name: 'Malicious Privileged User / Staff',
        abbreviation: 'Mal. Priv. User',
        capabilities:
            'High technical knowledge \r\n' +
            'Internal / insider knowledge about the operational environment',
        motiviation:
            'Ego, curiosity, rebellion, revenge \r\n' +
            'Enhances or unlocks functionality for free',
        typeOfAccess:
            'Intranet \r\n' +
            'Privileged physical and/or logical access to system hardware and software',
    }),
    AttackerType.new({
        isActor: true,
        name: 'Negligent User',
        abbreviation: 'Neg. User',
        capabilities: 'Insufficient security awareness',
        motiviation:
            'Boredom or playing around \r\n' +
            'Simplifies / improves efficiency or enjoyment of daily work (e.g., installation of unauthorized software like games on client devices, malware infection) \r\n' +
            'Negligent errors or omissions',
        typeOfAccess:
            'Physical and logical access to client assets as part of standard user activities',
    }),
    AttackerType.new({
        isActor: true,
        name: 'Negligent Privileged User / Staff',
        abbreviation: 'Neg. Priv. U.',
        capabilities:
            'High technical knowledge \r\n' +
            'Insufficient security competence',
        motiviation:
            'Simplifies / improves efficiency of daily work (e.g., negligent installation of unauthorized remote administration software) \r\n' +
            'Negligent degradation of security controls (e.g., changing security configurations)',
        typeOfAccess:
            'Privileged physical and/or logical access to system hardware and software',
    }),
];
